"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurriculumProduct = void 0;
/**
 * It contains information about curriculum and products associated with it
 *
 * @author mayuri.wankhade
 */
var CurriculumProduct = /** @class */ (function () {
    function CurriculumProduct(curriculumProduct) {
        if (curriculumProduct === void 0) { curriculumProduct = {}; }
        Object.assign(this, curriculumProduct);
    }
    return CurriculumProduct;
}());
exports.CurriculumProduct = CurriculumProduct;
